/* eslint-disable no-const-assign */
import "emoji-mart/css/emoji-mart.css";

import { Button, Divider, Input, message, Radio, Skeleton, Tag } from "antd";
import React, { useState } from "react";

import { useTagsContext } from "../TagsContext/TagsContext";

const BulkEdit = (props) => {
  /** *
   *  props.selectedMembers REQUIRED.
   *  Props.handleSave Required
   */
  const [selectedTag, setSelectedTag] = useState();
  const [newTag, setNewTag] = useState("");

  const {
    loading,
    teamTags,
    setTeamTags,
    loadTeamTags,
    addTag,
    addBulkTags,
    errors,
  } = useTagsContext();

  if (!props.selectedMembers) {
    return <Skeleton active />;
  }

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setSelectedTag(e.target.value);
  };

  const onTagNameChange = (event) => {
    event.preventDefault();
    setNewTag(event.target.value);
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  const handleAddTag = async () => {
    await addTag(newTag);
    if (errors.addTag) {
      message.error("Error adding tag, try again please.");
    } else {
      message.success("Success adding new tag!");
    }
    setNewTag("");
  };

  const handleAddBulkTag = async (tag, members) => {
    await addBulkTags(tag, members);
    if (errors.addBulkTags) {
      message.warning(
        "Bulk edit failed. Please refresh and try again, or contact support!"
      );
    } else {
      props.handleSave();
      setSelectedTag("");
      message.success("Tags added!");
    }
  };

  return (
    <>
      <div
        style={{
          height: 300,
          overflowY: "scroll",
        }}
      >
        <Radio.Group onChange={onChange} value={selectedTag}>
          {teamTags.map((item) => {
            return (
              <Radio style={radioStyle} key={item.id} value={item.id}>
                <Tag
                  style={{
                    border: `0.5px solid ${item.color}`,
                    borderRadius: 5,
                    width: "fit-content",
                  }}
                >
                  {item.name}
                </Tag>
              </Radio>
            );
          })}
        </Radio.Group>
      </div>

      {selectedTag ? (
        <div style={{ padding: 10, display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            onClick={() => handleAddBulkTag(selectedTag, props.selectedMembers)}
            loading={loading.addBulkTags}
          >
            Add selected tag to {props.selectedMembers.length} members
          </Button>
        </div>
      ) : null}

      <div>
        <Divider style={{ margin: "4px 0" }} />
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            padding: 8,
          }}
        >
          <Input
            placeholder="Enter a new tag"
            style={{ flex: "auto", borderRadius: 5 }}
            value={newTag}
            onChange={onTagNameChange}
            onKeyDown={(e) => e.stopPropagation()}
            disabled={loading.addTag}
          />
          <div className="pl-2">
            <Button
              type="primary"
              style={{
                flex: "none",
                display: "block",
                cursor: "pointer",
              }}
              onClick={() => handleAddTag(newTag)}
              loading={loading.addTag}
              disabled={newTag === ""}
            >
              + New tag
            </Button>
          </div>
        </div>
        {errors.addTag ? <p>Error adding tag, try again please</p> : ""}
      </div>
    </>
  );
};

export default BulkEdit;
